import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { CheckoutSessionRequest } from 'types/generated/models/CheckoutSessionRequest';
import { CheckoutSessionResponse } from 'types/generated/models/CheckoutSessionResponse';
import { client } from 'utils/api-client';

interface IUseCreateCheckoutSessionOptions {
  onSuccess?: (data: CheckoutSessionResponse) => void;
  onError?: (error: string) => void;
}

/**
 * Hook to create a Stripe checkout session via the payment methods API
 * Used for adding payment methods (BACS Debit or Card) for athletes
 */
function useCreateCheckoutSession(
  options: IUseCreateCheckoutSessionOptions = {},
): UseMutationResult<
  AxiosResponse<CheckoutSessionResponse>,
  AxiosError<{ message?: string; error?: string }>,
  CheckoutSessionRequest
> {
  const { onSuccess, onError } = options;

  const createCheckoutSession = (
    data: CheckoutSessionRequest,
  ): Promise<AxiosResponse<CheckoutSessionResponse>> => {
    return client.post('/payment-methods/checkout-session/', data);
  };

  return useMutation(createCheckoutSession, {
    onSuccess: response => {
      if (onSuccess) {
        onSuccess(response.data);
      }
    },
    onError: error => {
      const errorMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to create checkout session';

      if (onError) {
        onError(errorMsg);
      }
    },
  });
}

export default useCreateCheckoutSession;
